import React from 'react';
import { Modal, Card, Icon } from 'semantic-ui-react';
import styles from '../Components/styles/InventoryOverviewPopup.module.scss';
import stylesMobile from '../Components/styles/InventoryOverviewMobile.module.scss';
import RiskRow from '@components/Filtering/OverviewTable/InventorySimplifiedView/Components/RiskRow';
import { getQuantityType } from '../../../../../utils';
import { useTranslation } from 'react-i18next';

type Props = {
  isMobile: boolean;
  inventory: any;
};

const Title = ({ isMobile, inventory }: Props) => {
  const {
    envRisk,
    envRiskLevel,
    chemicalRiskAttributesSimplified,
    quantity,
    chemicalProduct,
    location,
  } = inventory || {};
  const { description, color } = envRiskLevel || '';
  const { chemRiskLevelResultSimplified } = chemicalRiskAttributesSimplified || {};
  const { chemRiskLevel } = chemRiskLevelResultSimplified || {};
  const { t } = useTranslation();

  return (
    <Modal.Header>
      <div className={isMobile ? stylesMobile.textMobileHeader : ''}>
        {`${chemicalProduct?.tradeName}: ${quantity} ${t(getQuantityType(chemicalProduct))}`}
      </div>
      <Card.Meta>
        <div
          className={
            isMobile ? stylesMobile.titleInventoryLocationMobile : styles.titleInventoryLocation
          }
        >
          <Icon.Group>
            <Icon name="map outline" />
            <Icon name="map marker alternate" corner="top right" color="black" />
          </Icon.Group>
          {location?.locationInfo}
        </div>
        <div
          className={isMobile ? stylesMobile.titleInventoryRiskMobile : styles.titleInventoryRisk}
        >
          {`${t('building.summary.page.risks.container.title')}:`}
          <RiskRow
            description={description}
            envRisk={envRisk}
            color={color}
            chemRiskLevel={chemRiskLevel}
          />
        </div>
      </Card.Meta>
    </Modal.Header>
  );
};

Title.defaultProps = {
  isMobile: false,
};

export default Title;
